import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

import { toast } from "../hooks/use-toast";
import { Toaster } from "../components/ui/toaster";
import { Link, useNavigate } from "react-router-dom";

import thumbImg from "../asset/orange-thumb.png";


// =========================
// THANK YOU MODAL
// =========================
const ThankYouModal = ({ open, onClose }) => {
  const navigate = useNavigate();

  if (!open) return null;

  const handleClose = () => {
    onClose();      // close modal
    navigate("/");  // redirect to home page
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-md rounded-2xl p-8 text-center shadow-xl relative">
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-black text-xl"
        >
          ×
        </button>

        <img src={thumbImg} alt="Success" className="w-20 h-20 mx-auto mb-4" />
        <h2 className="text-2xl font-bold mb-2">
          Sign up successful!
        </h2>

        <p className="text-gray-600">
          Please check your inbox for a verification<br/> email to complete your registration.
        </p>
      </div>
    </div>
  );
};


// =========================
// SIGNUP PAGE
// =========================
const Signup = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Input handler
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch("https://portal.aalign.io/services/signup.ashx", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: formData.email,
        }),
      });

      const result = await response.json();

      if (result.account_id) {
        setShowModal(true);
        setFormData({ firstName: "", lastName: "", email: "", password: "" });
      } 
      else if (
        result.error &&
        result.error.toLowerCase().includes("email") &&
        result.error.toLowerCase().includes("exist")
      ) {
        // Treat any "email exists" message as success
        setShowModal(true);
        setFormData({ firstName: "", lastName: "", email: "", password: "" });
      } 
      else {
        toast({
          title: "Error",
          description: result.error || "Something went wrong.",
          variant: "destructive",
        });
      }

    } catch (error) {
      toast({
        title: "Network Error",
        description: "Could not reach server. Try again later.",
        variant: "destructive",
      });
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <Toaster />

      <div className="flex-1 signup-wrapper">

        <style>
{`
  .signup-wrapper {
    display: flex;
    min-height: calc(100vh - 160px);
    background: #f6f2ec;
    font-family: 'Poppins', sans-serif;
    align-items: stretch;
  }

  /* LEFT PANEL */
  .left-panel {
    flex: 1.3;
    background: linear-gradient(135deg, #ff7a1c, #ff3c00);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    color: white;
    position: relative;
    overflow: hidden;
  }

  .circle1, .circle2, .circle3 {
    position: absolute;
    border-radius: 50%;
    filter: blur(40px);
    opacity: 0.3;
  }

  .circle1 { width: 300px; height: 300px; background: #ffce8a; top: -40px; left: -40px; }
  .circle2 { width: 250px; height: 250px; background: #ff9d00; bottom: 30px; right: -50px; }
  .circle3 { width: 180px; height: 180px; background: #ffffff; bottom: 180px; left: 80px; }

  .left-content h1 {
    font-size: 45px;
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 15px;
  }

  .left-content p {
    font-size: 16px;
    max-width: 350px;
    opacity: 0.9;
  }

  /* RIGHT PANEL */
  .right-panel {
    flex: 1;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 102px 50px;
    position: relative;
    overflow: hidden;
  }

  .form-container {
    width: 100%;
    max-width: 350px;
  }

  .form-container h2 {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 20px;
    color: #333;
  }

  .input-group { margin-bottom: 15px; }

  .input-group label {
    font-size: 14px;
    color: #444;
    margin-bottom: 5px;
    display: block;
  }

  .input-group input {
    width: 100%;
    padding: 12px;
    border-radius: 10px;
    border: 2px solid #e6e6e6;
    outline: none;
    transition: .2s;
    font-size: 14px;
  }

  .input-group input:focus {
    border-color: #ff7a1c;
    box-shadow: 0 0 8px rgba(255, 145, 0, 0.4);
  }

  .btn {
    width: 100%;
    padding: 14px;
    background: linear-gradient(135deg, #ff7a1c, #ff3c00);
    border: none;
    border-radius: 10px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    font-weight: 600;
    transition: 0.25s;
    margin-top: 5px;
  }

  .btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(255, 94, 0, 0.4);
  }

  .google-btn {
    width: 100%;
    border-radius: 10px;
    border: 2px solid #e6e6e6;
    padding: 12px;
    font-size: 14px;
    font-weight: 600;
    background: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: 0.2s;
    margin-top: 5px;
  }

  .google-btn:hover {
    background: #fafafa;
  }

  .divider {
    display: flex;
    align-items: center;
    margin: 25px 0;
  }

  .divider::before,
  .divider::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #ddd;
  }

  .divider span {
    margin: 0 10px;
    font-size: 13px;
    color: #777;
  }

  .terms {
    display: flex;
    justify-content: center;
    font-size: 12px;
    margin-top: 15px;
    margin-bottom: 10px;
    color: #555;
    text-align: center;
    line-height: 1.4;
    padding: 0px 5px;
    gap: 8px;
  }

  .terms a {
    color: #ff7a1c;
    font-weight: 600;
    text-decoration: none;
  }

  .login-links {
    margin-top: 10px;
    text-align: center;
    font-size: 13px;
  }

  .login-links a {
    color: #ff7a1c;
    font-weight: 600;
    text-decoration: none;
    margin: 0 5px;
  }

  .login-links a:hover { text-decoration: underline; }

  /* MOBILE */
  @media (max-width: 768px) {
    .left-panel {
      display: none !important;
    }

    .signup-wrapper {
      background: white;
    }

    .right-panel {
      width: 100%;
      padding: 65px 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media (max-width: 600px) {
    .form-container {
      max-width: 90%;
    }
  }
`}
</style>


        {/* LEFT PANEL */}
        <div className="left-panel">
          <div className="circle1"></div>
          <div className="circle2"></div>
          <div className="circle3"></div>

          <div className="left-content">
            <h1>Grow Your<br />Business Faster</h1>
            <p>Create your account and access our premium features to scale your business in 2025.</p>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="right-panel">
          <form className="form-container" onSubmit={handleSubmit}>
            <h2>Sign Up</h2>

            <div className="input-group">
              <label>First Name</label>
              <input
                type="text"
                name="firstName"
                required
                value={formData.firstName}
                onChange={handleChange}
                placeholder="Enter first name"
              />
            </div>

            <div className="input-group">
              <label>Last Name</label>
              <input
                type="text"
                name="lastName"
                required
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Enter last name"
              />
            </div>

            <div className="input-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter email"
              />
            </div>

            <div className="terms d-flex">
              <input type="checkbox" id="agree" required />
              <label htmlFor="agree">
                I agree to the <Link to="/terms-and-conditions">Terms & Conditions</Link> and <Link to="/privacy-policy">Privacy Policy</Link>.
              </label>
            </div>

            <button className="btn" type="submit" disabled={loading}>
              {loading ? "Creating account..." : "Create Account"}
            </button>

            <div className="divider">
              <span>OR</span>
            </div>

            <button type="button" className="google-btn">
              <img
                src="https://www.svgrepo.com/show/355037/google.svg"
                width="20"
                alt="Google"
              />
              Signin with Google
            </button>

            <p className="login-links">
              Already have an account?<br />
              
              <Link to="https://portal.aalign.io/login"> Login as Agency</Link> |
              <Link to="https://portal.aalign.io/partner/login"> Login as Partner</Link>
            </p>

          </form>
        </div>
      </div>

      <Footer />

      {/* UPDATED MODAL WITH REDIRECT */}
      <ThankYouModal open={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
};

export default Signup;
